import { render, staticRenderFns } from "./EmailNotificationTemplate.vue?vue&type=template&id=1bfbea3d&"
import script from "./EmailNotificationTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports